<template>
  <div class="hidden sm:flex absolute bottom-0 z-10 gap-1 justify-center items-center w-full h-8">
    <div class="px-3 py-3 flex justify-center items-center h-8 bg-gray-500 rounded-tl-lg rounded-tr-lg">
      <i class="material-icons text-white text-sm mr-1">event</i>
      <span class="text-white text-xs">Today: {{ dateToday }}</span>
    </div>
    <!-- <div class="px-3 py-3 flex justify-center items-center h-8 bg-gray-500 rounded-tl-lg rounded-tr-lg">
      <i class="material-icons text-white text-sm mr-1">directions_boat</i>
      <span class="text-white text-xs">Total: 23000 | MATI: 300 | AKTIF: 2000</span>
    </div> -->
  </div>
</template>

<script>
import libs from '../libs'

export default {
  name: 'Info',
  computed: {
    dateToday: () => libs.localTime(Date(), 'object').date
  }
}
</script>
